import { useContext } from 'react';
import { SettingsContext, SettingsContextType } from 'src/common/context/settings/SettingsContext';

export const useSettings = (): SettingsContextType => useContext(SettingsContext);
